import axios from "axios"
import { queryFixer } from "common/utils/utils"

export const createDepartamento = (value: $TSMigrationFixMe) =>
  axios.post(`/Departamento`, value)

export const getListadoDepartamentos = (queryState: $TSMigrationFixMe) => {
  const url = queryFixer(`/Departamento/by-filters`, queryState)
  return axios.get(url)
}

export const updateDepartamento = (
  idDepartamento: $TSMigrationFixMe,
  updatesValues: $TSMigrationFixMe
) =>
  axios.put(`/Departamento/${idDepartamento}`, {
    ...updatesValues,
  })
